export default __webpack_public_path__ + "static/media/enterprise_working.d3d93cf4.svg";